import kendo from '@progress/kendo-ui';
import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import moment from 'moment';
import { ConditionGroupOperator, ConditionOperator } from '../filters';
import { authService } from '../login';
import { reportsRepo } from './reportsRepo';

/*
 reportGrid

 Custom Knockout bindingHandler for rendering a reportGrid


 Here is an online example of multi-level column headers, i.e. grouping column headers:
 http://dojo.telerik.com/@george@trackmax.com/AHuZO
 
  Here is an example of the grid allowing you to expand a child grid and still scroll past the grid
  to see data that is after it in the parent grid.
  http://dojo.telerik.com/UXEma

  The following link is a copy of the above example but the parent grid scrolling was changed to virtual.
  It demonstrates a problem with scrolling down to see past an expanded child grid
  if scrolling in the parent grid is set to { virtual: true }.
  http://dojo.telerik.com/Atofa
 
 */

//Create a reference to the object
var reportGrid = {};

let singleNewRowArrowCell;

//Custom reportGrid binding handler
ko.bindingHandlers.reportGrid = reportGrid = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        // This will be called when the binding is first applied to an element
        // Set up any initial state, event handlers, etc. here
    },
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        // This will be called once when the binding is first applied to an element,
        // and again whenever any observables/computeds that are accessed change
        // Update the DOM element based on the supplied values here.

        var props = ko.toJS(valueAccessor());

        if (_.isNullOrUndefined(props.report) || _.isNullOrUndefined(props.report.reportId) || _.isNullOrUndefined(props.report.columns))
            return;

        //Get the properties that define the state of the grid.
        var stateProps = props.stateProps || {};
        var drillIntoFilters = stateProps.drillIntoFilters || [];
        var groupByFieldName = stateProps.groupByFieldName || "";
        var breakdownFieldName = stateProps.breakdownFieldName || "";
        var defaultSortObject = stateProps.defaultSortObject; //pass undefined if that's the case
        var isParentGrid = true; //always a parent grid at this point

        reportGrid.createGrid(element, props, groupByFieldName, drillIntoFilters, breakdownFieldName, isParentGrid, defaultSortObject);
    },
    createGrid: function (element, props, groupByFieldName, drillIntoFilters, breakdownGroupByFieldName, isParentGrid, defaultSortObject) {

        //Is this a top level grid?
        isParentGrid = _.defaultIfNullOrUndefined(isParentGrid, true);

        //Will this grid have child grids?
        var hasChildGrids = drillIntoFilters.length > 0 && _.last(drillIntoFilters).values.length > 1 && _.defaultIfNullOrUndefined(breakdownGroupByFieldName, "") !== "";

        //Get the report columns from the reportGridUI.
        //This makes sure we have the correct column widths every time.
        reportGrid.updateReportColumns(props);

        //Get the groupby column which by default is the first column returned from the api.
        //In the case of a breakdown menu click, the groupby column comes from a child grid.
        var groupByColumn = _.cloneDeep(_.nth(props.report.columns, 0));
        if (!_.isEmpty(groupByFieldName)) {
            //Get the groupby column from our list of breakdown columns and set it's width.
            var defaultWidth = groupByColumn.width;
            groupByColumn = reportGrid.getBreakdownGroupByColumn(props, groupByFieldName);
            if (groupByColumn != null) {
                groupByColumn.width = defaultWidth;
            }
        }

        //Get the columns that are configured to be displayed.
        var reportColumns = reportGrid.getReportColumns(props, groupByColumn, hasChildGrids);

        //Empty the element before redrawing the grid.
        //I found out the hard way that this is necessary. Aaargh!!
        $(element).empty();

        //Create a container for the kendo grid
        var gridId = "report-grid-" + _.random(1000000);
        var parentGridId = gridId;

        //Append the grid
        var $grid = $("<div id='{0}' class='report-grid-container' />".format(gridId)).appendTo($(element));

        if (isParentGrid) {

            //Add the grid data to the global transitionHandler.
            //First, clear out any existing data.
            transitionHandler.clear();
            transitionHandler.add(gridId, props, drillIntoFilters, isParentGrid)

            //Add a parent grid class to the grid
            $grid.addClass("parent-grid");

            //Create a container for the breakdown menu
            const menu = document.createElement("drilldown-menu");

            menu.id = 'breakdown-menu';

            element.append(menu);
        }
        else {

            //Add the grid data to our transition handler
            transitionHandler.add(gridId, props, drillIntoFilters, isParentGrid);

            var $parentGrid = $grid.closest(".parent-grid");
            parentGridId = $parentGrid.attr("id");
        }

        //Store data we need to look up later on the grid.
        //--drillIntoFilters
        //--groupByFieldName
        //--breakdownGroupByFieldName
        $grid.data("drill-into-filters", drillIntoFilters);
        if (groupByColumn != null) {
            $grid.data("group-by-fieldname", groupByColumn.field);
        }

        $grid.data("breakdown-group-by-fieldname", breakdownGroupByFieldName);

        //Get the dataSource
        var dataSource = reportGrid.getReportDataSource(gridId, props, reportColumns, drillIntoFilters, groupByColumn, breakdownGroupByFieldName, isParentGrid, defaultSortObject);

        //Create the detailInit function if there are multiple drillInto data values that we need to breakdown.
        var detailInitFunction = null;
        if (hasChildGrids) {

            var childGridGroupByColumn = reportGrid.getBreakdownGroupByColumn(props, breakdownGroupByFieldName);
            var childGridDrillIntoFieldName = groupByColumn.field;

            //Pass the current drillIntoFilters here so that the child grid init function can figure out what it will be upon expanding.
            detailInitFunction = new detailInitHandler(gridId, props, childGridGroupByColumn, childGridDrillIntoFieldName, drillIntoFilters, breakdownGroupByFieldName).detailInit;
        }

        //Set up the drillInto props that we will send back to the UI once the data is bound.
        var drillIntoProps = {};
        if (groupByColumn != null) {
            drillIntoProps.groupByFieldName = groupByColumn.field;
        }

        drillIntoProps.drillIntoFilters = drillIntoFilters;
        drillIntoProps.breakdownFieldName = breakdownGroupByFieldName;

        //Parent grids have a databound function
        var databoundFunction = isParentGrid ?
            reportGrid.getParentGridDataBoundFunction(element, props, $grid, hasChildGrids, drillIntoProps)
            : null;

        //Indent the first column if this is a child grid OR if this is a breakdown of a single row.
        if (!isParentGrid || (isParentGrid && !hasChildGrids && drillIntoFilters.length > 0 && _.defaultIfNullOrUndefined(breakdownGroupByFieldName, "") !== "")) {
            var firstDataCol = _.nth(reportColumns, 1);
            if (firstDataCol) {
                firstDataCol.attributes = firstDataCol.attributes || {};
                firstDataCol.attributes.class = firstDataCol.attributes.class || "";
                firstDataCol.attributes.class = firstDataCol.attributes.class.length == 0 ? "child-grid-first-column" : firstDataCol.attributes.class + " child-grid-first-column";
            }
        }

        var selectable = "multiple, row";

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            selectable = 'row';
        }

        //Create the grid
        $grid.kendoGrid({
            dataBound: databoundFunction,
            change: reportGrid.getGridChangeFunction($grid),
            pageable: true,
            sortable: true,
            selectable: selectable,
            groupable: false,
            resizable: true,
            reorderable: true,
            columnMenu: hasChildGrids ? false : true,
            noRecords: { template: "<div class='k-grid' style='float:left; margin:8px;'>No records to display</div>" },
            columns: reportColumns,
            dataSource: dataSource,
            detailInit: detailInitFunction,
            columnResizeHandleWidth: 10,
            columnResize: function (e) {
                if (_.isFunction(props.onColumnResized)) {

                    var grid = $grid.data("kendoGrid");

                    var cols = grid.columns;

                    _.forEach(cols, function (col) {
                        if (col.id == e.column.id) {
                            col.width = e.newWidth;
                        }
                    });

                    props.onColumnResized({ id: e.column.id, newWidth: e.newWidth });
                }
            }
        });
    },
    getDrillIntoFiltersGroup: function (props, drillIntoFilters) {
        return {
            groups: drillIntoFilters.map(({ field, values }) => ({
                conditions: values.map(value => ({
                    column: reportGrid.getBreakdownGroupByColumn(props, field).columnId,
                    operator: ConditionOperator.Equal,
                    value
                })),
                operator: ConditionGroupOperator.Or
            })),
            operator: ConditionGroupOperator.And
        };
    },
    //This call makes it possible to always get the latest version of the columns
    //with the correct widths applied. The column resizing in the grid updates the source of this function.
    updateReportColumns: function (props) {
        if (_.isFunction(props.getReportColumns)) {
            var cols = props.getReportColumns();
            props.report.columns = cols;
        }
    },
    getReportColumns: function (props, groupByColumn, hasChildGrids) {

        //Make a copy of the columns to work with. We need to keep the original columns intact so that they can be passed on to other grid calls.
        var reportColumns = _.cloneDeep(props.report.columns);

        //If the groupByColumn has a different field name than the first report column...
        if (!_.isNullOrUndefined(groupByColumn) && groupByColumn.field !== reportColumns[0].field) {

            //Swap out the first report column with the groupby column passed in.
            //Keep the width the same so the report alignment doesn't jump around.
            var originalWidth = reportColumns[0].width;
            reportColumns[0] = _.cloneDeep(groupByColumn);
            reportColumns[0].width = originalWidth;
        }

        if (!hasChildGrids) {
            var firstCol = _.nth(reportColumns, 0);
            if (firstCol != null) {
                firstCol.locked = true;
                firstCol.lockable = true;
            }
        }

        //Add a column for the breakdown menu arrow
        var menuColumn = {
            width: "18px",
            lockable: !hasChildGrids ? true : false,
            locked: !hasChildGrids ? true : false,
            attributes: {
                "class": "arrow-cell"
            }
        }
        reportColumns.splice(1, 0, menuColumn);

        //Update column templates
        reportGrid.updateColumnTemplates(reportColumns);

        //Add a dummy column to stretch and fill the remaining space
        var last = _.last(reportColumns);
        var dummyColumn = {}
        dummyColumn.width = "auto";
        dummyColumn.caption = "";
        dummyColumn.field = "";
        dummyColumn.title = "";
        dummyColumn.filterable = false;
        dummyColumn.columnOrder = last && last.columnOrder ? last.columnOrder + 1 : 1;
        dummyColumn.template = "";
        reportColumns.push(dummyColumn);

        return reportColumns;
    },
    updateColumnTemplates: function (columns) {

        _.forEach(columns, function (column, indx) {

            if (column.format == "date") {
                //Add a template to the columns to format each cell. The template will format a date
                column.template = "#= kendo.toString(kendo.parseDate(" + column.field + ", 'yyyy-MM-dd'), 'MM/dd/yyyy') #";
            }
            else if (column.columnTypeString && column.columnTypeString.indexOf("Delta") === 0) {
                column.template = "<span class='#= (" + column.field + " > 0) ? \'trend-up\' : \'trend-down\' #'>#= (" + column.field + " == null) ? \'\' : kendo.toString(" + column.field + ", \'" + column.format + "\') #</span>";
            }
            else if (column.field && (column.allowReportTransition || column.format)) {

                //Display NULL values as empty string
                var valueTemplate = column.format ? "#= (" + column.field + " == null) ? \"\": kendo.toString(" + column.field + ", \"" + column.format + "\") #"
                    : "#= (" + column.field + " == null) ? \"\" : " + column.field + " #";

                //Add red font color to negative numbers
                column.template = "<span class='#= (" + column.field + " < 0) ? \'trend-down\' : \'\' #'>" + valueTemplate + "</span>";

                if (column.allowReportTransition) {
                    column.template = "<a onclick='return window.transitionHandler.process(this, " + column.columnId + ");'>" + column.template + "</a>";
                }
            }

            //Add a column footer template
            if (column.field && column.dataTypeString != "string" && column.dataTypeString != "date") {
                column.footerTemplate = "<div class='footer-" + column.field.toLowerCase() + " text-right'></div>";
            }
        });

        return columns;
    },
    getBreakdownGroupByColumn: function (props, breakdownGroupByField) {

        var breakdownCols = _.flattenDeep(_.map(props.breakdownColumns, "items"));
        var result = _.find(breakdownCols, function (col) { return _.lowerCase(col.field) === _.lowerCase(breakdownGroupByField); });

        if (!result) {
            result = _.find(breakdownCols, function (col) { return _.lowerCase(col.caption) === _.lowerCase(breakdownGroupByField); });
        }

        return result;
    },
    //Push changed drillInto properties up the chain through the onDrillIntoPropertiesUpdated callback, if defined.
    updateDrillIntoProperties: function (props, drillIntoProps) {

        if (_.isFunction(props.onDrillIntoPropertiesUpdated)) {
            props.onDrillIntoPropertiesUpdated(drillIntoProps);
        }
    },
    //Push changed sort properties up the chain through the onSortPropertiesUpdated callback, if defined.
    updateSortProperties: function (props, sortProps) {

        if (_.isFunction(props.onSortPropertiesUpdated)) {
            props.onSortPropertiesUpdated(sortProps);
        }
    },
    getParentGridDataBoundFunction: function (element, props, $grid, expandChildGrids, drillIntoProps) {

        var onDatabound = function (e) {
            let drilldownMenuX;
            let drilldownMenuY;
            let openingDrilldown;
            let previousArrowCell;

            //Trigger a window resize so that our UI resizes the grid after any new grid content has been displayed.
            setTimeout(() => $grid.data('kendoGrid').resize(), 100);

            //Update drillInto properties if this is a top-level grid request.
            reportGrid.updateDrillIntoProperties(props, drillIntoProps);

            //Reference the grid
            var grid = $grid.data("kendoGrid");

            //Expand all the child grid rows?
            if (_.defaultIfNullOrUndefined(expandChildGrids, false) && !_.isNullOrUndefined(grid) && _.isFunction(grid.expandRow)) {
                grid.expandRow(grid.tbody.find("tr.k-master-row"));
            }

            const menu = document.getElementById('breakdown-menu');

            document.body.addEventListener('click', ({ target }) => {
                const { classList } = target;

                if (classList.contains('arrow-cell') ? target === singleNewRowArrowCell : target !== menu) {
                    menu.close();
                }

                singleNewRowArrowCell = undefined;
            });

            element.addEventListener('click', event => {
                const { pageX, pageY, target } = event;

                if (target.classList.contains('arrow-cell') && target !== singleNewRowArrowCell) {
                    clearTimeout(openingDrilldown);

                    openDrilldownMenu(target, pageX, pageY);
                }
            });

            element.addEventListener('mouseout', ({ target }) => {
                if (target.classList.contains('arrow-cell')) {
                    clearTimeout(openingDrilldown)
                }
            });

            element.addEventListener('mouseover', ({ pageX, pageY, target }) => {
                const { classList } = target;
                if (classList.contains('arrow-cell') && classList.contains('selected')) {
                    openingDrilldown = setTimeout(
                        () => openDrilldownMenu(target, pageX, pageY),
                        300
                    );
                }
            });

            menu.addEventListener('optionselect', ({ detail }) => {
                //Reference the grid that the menu is hovering over
                var menuGridId = $("#breakdown-menu").data("report-grid-id");
                var $menuGrid = $("#" + menuGridId);
                var menuGrid = $menuGrid.data("kendoGrid");

                //Get stored data from the grid
                var drillIntoFilters = $menuGrid.data("drill-into-filters");
                var currentGroupByFieldName = $menuGrid.data("group-by-fieldname");

                //Get the selected breakdown column
                var breakdownColumn = reportGrid.getBreakdownGroupByColumn(props, detail);

                //Get the selected grid rows
                var selectedGridRows = menuGrid.select();

                //Set the field name that will be displayed as the first column in the new grid.                   
                var groupByFieldName = null;
                if (selectedGridRows.length / 2 <= 1) {
                    //If only one row was selected for breakdown, change the first column to the breakdown field.
                    groupByFieldName = breakdownColumn.field;
                }
                else {
                    //If multiple rows were selected for breakdown, keep the first column the same as it is now.
                    groupByFieldName = currentGroupByFieldName;
                }

                //Add the newly selected grid rows to the drillIntoFilters array.

                //If a filter already exists with this group by field name, use it.
                var filter = _.find(drillIntoFilters, function (df) { return df.field === currentGroupByFieldName; });
                if (_.isNullOrUndefined(filter)) {
                    filter = {
                        field: currentGroupByFieldName,
                        values: [],
                        type: selectedGridRows.length > 0 ? "or" : "and" //Multiple selected rows are inclusive ("or"), otherwise "and".
                    };

                    drillIntoFilters.push(filter);
                }

                _.forEach(selectedGridRows, function (row) {
                    var dataItem = menuGrid.dataItem(row);

                    var filterAlreadyAdded = false; //the kendo grid passes 2 selected rows if a column freeze has been applied (we only need it in there once)
                    for (var i = 0; i < filter.values.length; i++) {
                        if (filter.values[i] == dataItem[currentGroupByFieldName]) {
                            filterAlreadyAdded = true;
                        }
                    }

                    if (filterAlreadyAdded == false) {
                        filter.values.push(dataItem[currentGroupByFieldName] || "");
                    }

                }).data("kendoMenu");

                //Get sort object stored in the DOM on the parent grid
                var sortObject = $grid.data("sort");

                //Get the dataItem and pass to our create grid function
                reportGrid.createGrid(element, props, groupByFieldName, drillIntoFilters, breakdownColumn.field, null, sortObject, false);
            });

            menu.addEventListener('menuclose', () => previousArrowCell = undefined);

            menu.options = props.breakdownColumns.map(({ items, text }) => ({
                category: text,
                options: items.map(({ caption }) => caption)
            }));

            function openDrilldownMenu(arrowCell, x, y) {
                const { classList } = arrowCell;

                if (!classList.contains('selected'))
                    return;

                var menu = document.getElementById('breakdown-menu');

                //We need to store the grid's element id on the menu so that later on,
                //in the menu select event handler, we know which grid was involved.
                var menuGrid = arrowCell.closest('.report-grid-container');

                menu.dataset.reportGridId = menuGrid.id;

                if (arrowCell === previousArrowCell) {
                    x = drilldownMenuX;
                    y = drilldownMenuY;
                }

                drilldownMenuX = x;
                drilldownMenuY = y;
                previousArrowCell = arrowCell;

                menu.open(x, y);
            }
        }

        return onDatabound;
    },
    getGridChangeFunction: function ($grid) {

        var onChange = function (e) {
            //Get the current selected rows
            var grid = $grid.data("kendoGrid");
            var rows = grid.select();

            const arrowCells = rows.find('.arrow-cell');

            singleNewRowArrowCell = arrowCells.length === 1 && !arrowCells.hasClass('selected')
                ? arrowCells.get(0)
                : undefined;

            //Remove existing arrows
            $grid.find(".arrow-cell").removeClass("selected glyphicon glyphicon-chevron-right");

            //Add an arrow and selected class to all rows that are actually selected
            _.forEach(rows, function (row) {
                var $arrowCell = $(row).find(".arrow-cell");
                $arrowCell.addClass("selected glyphicon glyphicon-chevron-right");
            });
        }

        return onChange;
    },

    updateTrendColumnTitles: function (gridId, columns, reportDates) {

        //Find all columns of trend type, then loop through them and update their title.
        var trendCols = _.filter(columns, function (col) { return col.columnTypeString === "Trend" || col.columnTypeString === "Delta" || col.columnTypeString === "DeltaPercentage"; });

        _.each(trendCols, function (col) {
            var trendDateRange = _.nth(reportDates, col.trendIndex);
            if (trendDateRange) {

                //Format the dates
                var start = moment(trendDateRange.startDate).format("MM/DD/YYYY");
                var end = moment(trendDateRange.endDate).format("MM/DD/YYYY");

                //Add the date range to the header text
                var dateString = "[" + start + " - " + end + "]";
                var hdrText = col.title + "    " + dateString;

                //Add the header text to the DOM element
                var hdrElement = $("#" + gridId).find("th[data-field=" + col.field + "]").first();
                var hdrElementLink = hdrElement.contents().last();
                var nestedElements = hdrElementLink.children(); //grab any nested elements we don't want overwritten
                hdrElementLink.text(hdrText).append(nestedElements); //update the text and then append back any nested elements
            }
        });
    },
    getReportDataSource: function (gridId, props, columns, drillIntoFilters, groupByColumn, breakdownGroupByFieldName, isParentGrid, defaultSortObject) {

        var pageSize = isParentGrid ? props.pageSize || 250 : 10;
        var onRequestCompleted = props.onRequestCompleted;
        var dataUrl = reportGrid.getDataUrl(props, columns, drillIntoFilters, groupByColumn, breakdownGroupByFieldName);

        var postData = {};
        if (!_.isNullOrUndefined(props.dateRangeOverride) && props.overrideDateRange === true) {
            postData.dateRangeOverride = props.dateRangeOverride;
            postData.overrideDateRange = true;
        }
        if (props.filters) {
            postData.reportFiltersOverride = props.filters;
            postData.overrideReportFilters = true;
        }

        //Get the schema model which handles data type hints for the grid
        var schemaModel = reportGrid.getGridSchemaModel(columns);

        //Get sort object
        var sortObject = reportGrid.getSortObject(columns, defaultSortObject, props.report.sortColumn);

        return new kendo.data.DataSource({
            type: 'odata-v4',
            transport: {
                read: {
                    async: true,
                    url: dataUrl,
                    dataType: "json",
                    data: postData,
                    processData: true,
                    type: "POST",
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
                    },
                    complete: function (xhr, status) {

                        //Let the outside world know what happened.
                        if (_.isFunction(onRequestCompleted)) {
                            onRequestCompleted(xhr, status, this.url);
                        }

                        //Update the column header and footer rows
                        if (isParentGrid && xhr.responseJSON && xhr.responseJSON.summary) {

                            //Determine if we should show a header row.
                            //Show a header row if the last item in the drillIntoFilters array has only one value to display (not multiple for breakdowns).
                            var lastFilter = _.last(drillIntoFilters);
                            var showHeaderRow = !_.isNullOrUndefined(lastFilter) && _.isArray(lastFilter.values) && lastFilter.values.length <= 1 && _.defaultIfNullOrUndefined(breakdownGroupByFieldName, "") !== "";

                            var $grid, grid, $thead, drillIntoValue, $headerRowFrozen, $theadNonFrozen;
                            var $headerRowNonFrozen = "";

                            if (showHeaderRow) {
                                $grid = $("#" + gridId);
                                grid = $grid.data("kendoGrid");
                                $thead = $grid.find("thead").first();


                                //Remove the drillInto header row if it exists already
                                $thead.find(".k-master-row").remove();

                                drillIntoValue = lastFilter.values[0] || "";

                                $headerRowFrozen = $("<tr class='k-master-row'></tr>");
                            }

                            //Loop through the columns and set the header/footer cells for each one
                            _.forEach(columns, function (col, indx) {

                                var colIsValid = !_.isNullOrUndefined(col.field) && !_.isNullOrUndefined(col.format);

                                var value = colIsValid ? kendo.toString(_.result(xhr.responseJSON.summary, col.field, 0), col.format) || "" : "";

                                if (value.toLowerCase() === "null")
                                    value = "";

                                //Find the footer in the UI and update it's value
                                if (colIsValid)
                                    $("div.footer-" + col.field.toLowerCase()).text(value);

                                //If true, build a header cell for each column
                                if (showHeaderRow) {

                                    //Add a table cell for each column
                                    if (indx === 1) {
                                        //The first table cell (not including the arrow cell) will display the drillIntoValue
                                        $headerRowFrozen[0].innerHTML = "<td>{0}</td>".format(drillIntoValue);
                                    }
                                    else {

                                        //Numeric data is right aligned
                                        var formatClass = col.field && col.dataTypeString != "string" ? "text-right" : "";

                                        $headerRowNonFrozen += "<td class='" + formatClass + "'>" + value + "</td>";
                                    }
                                }

                            });

                            if (showHeaderRow) {
                                $thead.append($headerRowFrozen);
                                //DCM - 10/4/2016 this is the summary row for a drill into.  This broke the click to sort header functionality
                                // $grid.find("thead")[1].className = "k-master-row";
                                // $grid.find("thead")[1].innerHTML += '<tr role="row">' + $headerRowNonFrozen + '</tr>';
                            }
                        }

                        //Add dates to the trend column header text
                        if (isParentGrid && xhr.responseJSON && xhr.responseJSON.reportDates && xhr.responseJSON.reportDates.length > 0)
                            reportGrid.updateTrendColumnTitles(gridId, columns, xhr.responseJSON.reportDates);
                    }
                },
                parameterMap: function (data, type) {

                    //Map the sort properties and row props to our postdata for the ReportContentController method the grid will call
                    var sortObj = data.sort && data.sort.length > 0 ? data.sort[0] : {};

                    var sortField = sortObj.field;
                    var sortDirection = sortObj.dir;
                    var topRows = data.take || 750;
                    var skipRows = data.skip || 0;

                    var postParams = {};
                    postParams.sortField = sortField;
                    postParams.sortDirection = sortDirection;
                    postParams.topRows = topRows;
                    postParams.skipRows = skipRows;

                    return $.extend(postParams, postData);
                }
            },
            filter: {},
            pageSize: 100,
            serverFiltering: true,
            serverPaging: true,
            serverSorting: true,
            change: function (e) {

                if (isParentGrid) {

                    //Store the parent grid's sort objects in the DOM.
                    //The child grids will be redrawing themselves shortly and 
                    //they will need to grab the new sort from within the detailInit handler.
                    var sort = e.sender._sort || null;

                    var sortObj = sort && sort.length > 0 ? sort[0] : {};

                    $("#" + gridId).data("sort", sortObj);

                    //Get the column being sorted
                    var sortColumn = _.find(columns, function (c) { return c.field === sortObj.field; });

                    reportGrid.updateSortProperties(props, { sortField: sortObj.field, sortDirection: sortObj.dir, reportId: props.report.reportId, column: sortColumn });
                }
            },
            sort: [sortObject],
            reordable: true,
            resizable: true,
            schema: {
                data: "results",
                total: function (data) {
                    return data['resultCount'];
                },
                model: schemaModel
            }
        });
    },
    getGridSchemaModel: function (columns) {

        //Create the schema model
        var gridSchemaModel = {};
        gridSchemaModel.fields = {};

        _.forEach(columns, function (column) {

            //Process grid schema model
            var field = gridSchemaModel.fields[column.field] = {};
            field.type = column.dataTypeString == "string" ? "string" : column.dataTypeString == "date" ? "date" : "number";

        });

        return gridSchemaModel;
    },
    getSortObject: function (columns, defaultSortObject, reportSortColumnValue) {

        //If the default sort object is valid, return it.
        //Otherwise, continue on and get the sort object from the columns array.
        if (!_.isNullOrUndefined(defaultSortObject)) {
            var match = _.find(columns, function (col) { return col.field === defaultSortObject.field && !_.isNullOrUndefined(col.columnId); });
            if (!_.isNullOrUndefined(match)) {
                return defaultSortObject
            }
        }

        //Get the sort object from the reportSortColumnValue if it is valid
        if (!_.isNullOrUndefined(reportSortColumnValue) && (reportSortColumnValue.indexOf(" Desc") > -1 || reportSortColumnValue.indexOf(" Asc") > -1)) {
            var sortObj = {};
            sortObj.field = reportSortColumnValue.substring(0, reportSortColumnValue.indexOf(" "));
            sortObj.dir = reportSortColumnValue.substring(reportSortColumnValue.indexOf(" ") + 1).toLowerCase();
            return sortObj;
        }

        //No sort columns were defined, so sort by the first column
        var firstColumn = columns[0] || {};
        return { field: firstColumn.field, dir: firstColumn.DisplayFormat == null ? "asc" : "desc" };
    },
    getDataUrl: function (props, columns, drillIntoFilters, groupByColumn, breakdownGroupByFieldName) {

        //NOTE: When creating the URL for the grid to send to the API, keep the following in mind:
        //  -- drillIntoFilter: drives the filter applied to data coming back
        //  -- breakdownGroupBy: drives the grouping of the data coming back.

        //Add the report id parameter
        var dataUrl = `${API_URL}/reportcontent?reportId={0}`.format(props.report.reportId);

        //Determine if the last filter contains multiple filter values (which means we're looking at a breakdown comparison of multiple rows).
        //NOTE: when checking the last filter for multiple values, make sure it's not a filter that was added by the "jump to" transition dialog.
        var lastFilter = _.last(drillIntoFilters);
        var breakdownMultipleRows = !_.isNullOrUndefined(lastFilter) && _.defaultIfNullOrUndefined(lastFilter.transitionFilter, false) === false && lastFilter.values.length > 1;

        if (!breakdownMultipleRows && !_.isNullOrUndefined(breakdownGroupByFieldName) && breakdownGroupByFieldName.length > 0) {
            //There was only a single row selected to breakdown.
            dataUrl = dataUrl + "&breakdownGroupBy={0}".format(breakdownGroupByFieldName);
        }
        else if (breakdownMultipleRows && !_.isNullOrUndefined(lastFilter.field)) {
            //There were multiple rows selected for a breakdown comparison.
            //Send the last filter's field as the breakdown group by.
            //When the data comes back and the child grids expand, they will send requests that contain
            //the breakdownGroupByFieldName above.
            dataUrl = dataUrl + "&breakdownGroupBy={0}".format(lastFilter.field);
        }
        else if (!breakdownMultipleRows && groupByColumn) {

            var firstColumn = _.nth(_.filter(columns, function (c) { return c.isArrowColumn !== true; }), 0);

            //Check to see if the first column matches the groupByColumn.
            //If not, we need to send the breakdownGroupBy parameter with the groupByColumn.field.
            if (groupByColumn.field !== firstColumn.field) {
                dataUrl = dataUrl + "&breakdownGroupBy={0}".format(groupByColumn.field);
            }
            else {

                //If the first column matches the group by column, and the group by column is filtered by the last filter
                //we need to send the group by column field in the breakdownGroupBy parameter
                if (breakdownGroupByFieldName.length < 1 && !_.isNullOrUndefined(lastFilter) && firstColumn.field == lastFilter.field) {
                    dataUrl = dataUrl + "&breakdownGroupBy={0}".format(lastFilter.field);
                }
            }
        }

        var drillIntoGroup = reportGrid.getDrillIntoFiltersGroup(props, drillIntoFilters);
        if (drillIntoGroup.groups.length > 0) {
            dataUrl += "&drillIntoFilter={0}".format(encodeURIComponent(JSON.stringify(drillIntoGroup)));
        }

        return dataUrl;
    }
};

var detailInitHandler = (function () {

    var _parentGridId = "", _props, _groupByColumn, _drillIntoFieldName, _drillIntoFilters, _breakdownGroupByFieldName;

    function detailInitHandler(parentGridId, props, groupByColumn, drillIntoFieldName, drillIntoFilters, breakdownGroupByFieldName) {
        _parentGridId = parentGridId;
        _props = props;
        _groupByColumn = groupByColumn;
        _drillIntoFieldName = drillIntoFieldName;
        _drillIntoFilters = drillIntoFilters;
        _breakdownGroupByFieldName = breakdownGroupByFieldName;
    }

    detailInitHandler.prototype.detailInit = function (e) {

        //Get the dataItem from the master row
        var dataItem = e.sender.dataItem(e.masterRow);

        var dataValue = "";
        if (!_.isNullOrUndefined(_drillIntoFieldName) && _drillIntoFieldName.length > 0) {
            dataValue = dataItem[_drillIntoFieldName] || "";
        }

        //Get all drillIntoFilters excluding the last one
        var drillIntoFilters = _drillIntoFilters.length > 1 ? _.slice(_drillIntoFilters, 0, _drillIntoFilters.length - 1) : [];

        drillIntoFilters.push({ field: _drillIntoFieldName, values: [dataValue] });

        //Get the parent grid's sort and use it for this child grid too.
        var $gridElement = $("#" + _parentGridId);
        var childSort = _.cloneDeep($gridElement.data("sort") || {});

        //If parent grid is sorted by the first column, check to see if there is a breakdown field.
        //If so, set the child sort field to that field.
        //This way the child grids will sort by the first column too.
        var firstColumn = _.find(_props.report.columns, function (col) { return col.columnOrder === 1; });
        if (firstColumn && firstColumn.field && firstColumn.field === childSort.field && _breakdownGroupByFieldName) {
            childSort.field = _breakdownGroupByFieldName;
        }

        //Create the grid
        reportGrid.createGrid(e.detailCell, _props, _groupByColumn.field, drillIntoFilters, _breakdownGroupByFieldName, false, childSort);
    }

    return detailInitHandler;
})();


var reportGridsTransitionHandler = (function () {

    var _gridData = [];

    function reportGridsTransitionHandler() {
        _gridData = [];
    }

    //Clear the grid data
    reportGridsTransitionHandler.prototype.clear = function () {
        _gridData = [];
    }

    //Add grid data for a specific grid that will allow transitions
    reportGridsTransitionHandler.prototype.add = function (gridId, props, drillIntoFilters, isParentGrid) {

        var data = _.find(_gridData, function (g) { return g.gridId === gridId; });

        if (!data) {
            data = { gridId: gridId };
            _gridData.push(data);
        }

        data.props = props;
        data.drillIntoFilters = drillIntoFilters;
        data.isParentGrid = isParentGrid;
    }

    //Update the selected rows
    var updateGridRowSelection = function ($gridEl, $rowEl) {

        //Reference the grid
        var grid = $gridEl.data("kendoGrid");

        //Get the uid for the row we want to check
        var uid = $rowEl.data("uid");

        //Determine if the passed in row is already selected in the grid
        var selectedGridRows = grid.select();
        var rowIsSelected = false;
        _.forEach(selectedGridRows, function (row) {
            var rowUid = $(row).data("uid");
            if (rowUid && rowUid === uid)
                rowIsSelected = true;
        })

        if (!rowIsSelected) {
            grid.clearSelection();
            grid.select($rowEl[0]);
        }
    }

    //Process a grid transition
    reportGridsTransitionHandler.prototype.process = async function (element, columnId) {

        //Get the grid and row elements
        var $element = $(element);
        var $gridEl = $element.closest(".k-grid");
        var $rowEl = $element.closest("tr");

        if ($gridEl.length > 0 && $rowEl.length > 0) {

            //Update the row selection
            updateGridRowSelection($gridEl, $rowEl);

            var gridId = $gridEl.attr("id");

            //Get the data we need to transition the grid
            var data = _.find(_gridData, function (g) { return g.gridId === gridId; });

            if (data) {

                //Check to see if the callback exists
                if (!_.isNullOrUndefined(data.props.onTransitionClick)) {

                    //Reference the grid
                    var grid = $gridEl.data("kendoGrid");

                    //Store the filters for drillInto and row selection
                    var filters = [];

                    var drillIntoFilters = _.cloneDeep(data.drillIntoFilters); //clone because then we won't alter the array for everyone else. 

                    //Add the drillInto filters
                    _.forEach(drillIntoFilters, function (f) {

                        //Make sure the filter has a field value.
                        //Don't add filters that were used to transition to this report from a previous one.
                        if (f.field && _.defaultIfNullOrUndefined(f.transitionFilter, false) === false) {

                            _.forEach(f.values, function (v) {

                                var filter = {
                                    columnId: null,
                                    column: null,
                                    fieldName: f.field,
                                    operator: "eq",
                                    value: v,
                                    type: "and"
                                }

                                filters.push(filter);
                            })
                        }
                    })

                    //Get the row filters
                    var clickedColumn = _.find(data.props.allColumns || [], function (col) { return col.columnId === columnId });

                    const fieldName = clickedColumn.field;

                    var rowFilters;

                    var selectedGridRows = grid.select();

                    const listOfValuesColumns = await reportsRepo.getListOfValuesColumns();

                    const listOfValues = listOfValuesColumns.some(column => column.columnId === columnId);

                    let values = selectedGridRows.get().map(row => grid.dataItem(row)[fieldName]);

                    values = Array.from(new Set(values));

                    if (listOfValues) {
                        rowFilters = [{
                            column: clickedColumn,
                            columnId,
                            fieldName,
                            listValues: values,
                            operator: 'list',
                            type: 'and'
                        }];
                    } else {
                        rowFilters = values.map(value => ({
                            columnId: clickedColumn.columnId,
                            column: clickedColumn,
                            fieldName,
                            operator: "eq",
                            value,
                            type: "or"
                        }));
                    }

                    //Add the row filters to the drillInto filters
                    _.forEach(rowFilters, function (f) {
                        filters.push(f);
                    });

                    //Pass the filters to the callback
                    data.props.onTransitionClick(filters);
                }
            }
        }
    }

    return reportGridsTransitionHandler;
})();

//This object holds a reference to a global reportGridsTransitionHandler.
//The transition handler keeps track of the grids that need to transition.
//Any columns that have a property of AllowReportTransition = true will have hyperlinks that make a call to the transition handler.
var transitionHandler = new reportGridsTransitionHandler();
window.transitionHandler = transitionHandler;
